import React, { useEffect, useState } from 'react';
import AdminApi from './AdminApi';

/**
 * Trang thông tin cá nhân (feature 002 - US3).
 * Người dùng tự sửa họ tên, địa chỉ và đổi mật khẩu của chính mình (/account/me*).
 */
const AdminProfilePage = () => {
    const [profile, setProfile] = useState({ name: '', address: '', username: '', role: '' });
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState(null); // {type:'success'|'error', text}
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        AdminApi.getMe()
            .then((data) => {
                if (data) setProfile({ name: data.name || '', address: data.address || '', username: data.username || '', role: data.role || '' });
            })
            .catch(() => setMessage({ type: 'error', text: 'Không tải được thông tin tài khoản.' }));
    }, []);

    const handleSave = async () => {
        setMessage(null);
        if (!profile.name.trim()) {
            setMessage({ type: 'error', text: 'Vui lòng nhập họ tên.' });
            return;
        }
        if (newPassword || password || confirmPassword) {
            if (!password) { setMessage({ type: 'error', text: 'Vui lòng nhập mật khẩu hiện tại.' }); return; }
            if (newPassword.length < 6) { setMessage({ type: 'error', text: 'Mật khẩu mới phải có ít nhất 6 ký tự.' }); return; }
            if (newPassword !== confirmPassword) { setMessage({ type: 'error', text: 'Xác nhận mật khẩu không khớp.' }); return; }
        }
        setIsLoading(true);
        const payload = { name: profile.name, address: profile.address };
        if (newPassword) { payload.password = password; payload.newPassword = newPassword; }
        const res = await AdminApi.updateMe(payload);
        setIsLoading(false);
        if (res.ok) {
            localStorage.setItem('userName', profile.name || localStorage.getItem('userName'));
            setMessage({ type: 'success', text: newPassword ? 'Đã lưu và đổi mật khẩu thành công!' : 'Đã lưu thông tin!' });
            setPassword(''); setNewPassword(''); setConfirmPassword('');
        } else {
            const serverMsg = res.data && (res.data.message || (res.data.body && res.data.body.message));
            setMessage({ type: 'error', text: serverMsg || 'Lưu thất bại. Kiểm tra lại mật khẩu hiện tại.' });
        }
    };

    const fieldStyle = { display: 'block', width: '100%', maxWidth: '420px', marginBottom: '14px' };
    const labelStyle = { display: 'block', marginBottom: '4px' };

    return (
        <div className="social-box">
            <h3 className="page-title">Thông tin cá nhân</h3>
            <div className="body">
                {message && (
                    <div style={{
                        padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontWeight: 600,
                        background: message.type === 'success' ? '#e7f6ec' : '#fdecec',
                        color: message.type === 'success' ? '#1c8c3c' : '#cf383d',
                        border: `1px solid ${message.type === 'success' ? '#bfe5cb' : '#f5c6c6'}`
                    }}>{message.text}</div>
                )}

                <label style={labelStyle}>Tên đăng nhập</label>
                <input type="text" value={profile.username} disabled style={{ ...fieldStyle, background: '#f3f4f6' }} />

                <label style={labelStyle}>Vai trò</label>
                <input type="text" value={profile.role} disabled style={{ ...fieldStyle, background: '#f3f4f6' }} />

                <label style={labelStyle}>Họ tên</label>
                <input type="text" value={profile.name} onChange={e => setProfile(p => ({ ...p, name: e.target.value }))} style={fieldStyle} />

                <label style={labelStyle}>Địa chỉ / Email liên hệ</label>
                <input type="text" value={profile.address} onChange={e => setProfile(p => ({ ...p, address: e.target.value }))} style={fieldStyle} />

                <h4 style={{ margin: '22px 0 12px', paddingTop: '16px', borderTop: '1px solid #e4e8ee' }}>Đổi mật khẩu <span style={{ fontWeight: 400, color: '#6b7684', fontSize: '13px' }}>(bỏ trống nếu không đổi)</span></h4>

                <label style={labelStyle}>Mật khẩu hiện tại</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} style={fieldStyle} autoComplete="current-password" />

                <label style={labelStyle}>Mật khẩu mới (≥ 6 ký tự)</label>
                <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={fieldStyle} autoComplete="new-password" />

                <label style={labelStyle}>Nhập lại mật khẩu mới</label>
                <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} style={fieldStyle} autoComplete="new-password" />

                <div style={{ marginTop: '18px' }}>
                    <button type="button" className={`btn btn-success ${isLoading ? 'is-loading' : ''}`} onClick={handleSave} disabled={isLoading}>
                        Lưu thay đổi
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminProfilePage;
